import { render, staticRenderFns } from "./NewsletterSubscribePopup.vue?vue&type=template&id=299a7a8e&"
import script from "./NewsletterSubscribePopup.vue?vue&type=script&lang=js&"
export * from "./NewsletterSubscribePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('299a7a8e', component.options)
    } else {
      api.reload('299a7a8e', component.options)
    }
    module.hot.accept("./NewsletterSubscribePopup.vue?vue&type=template&id=299a7a8e&", function () {
      api.rerender('299a7a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/newsletter-subscribe-popup/NewsletterSubscribePopup.vue"
export default component.exports